/** Styl pro skupinu komponenty input k tématu Erma */
export const InputgroupStyles = {
  addon: {
    background: '#eaeaea',
    padding: '.429rem',
    borderRadius: 'var(--erma-border-radius-sm)',
    borderColor: '#a6a6a6',
    color: '#848484'
  }
};
